import { Component, Inject, OnInit, Output } from "@angular/core";
import { NotificationsService } from "../../../services/notifications.service";
import {
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatSelect,
	MatDatepickerInputEvent,
} from "@angular/material";
import { MessageService } from "src/services/message.service";

@Component({
	selector: "app-adduserlist",
	templateUrl: "./adduserlist.component.html",
	styleUrls: ["./adduserlist.component.css"],
})
export class AdduserlistComponent implements OnInit {
	public userList: any[];
	public assignedUsers: any[] = [];
	listChanges: boolean;
	searchTxt: string = "";
	searchByText: boolean = false;

	constructor(
		private notificationsService: NotificationsService,
		private dialogRef: MatDialogRef<AdduserlistComponent>,
		private msgService: MessageService,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit() {
		this.getUsersList();
	}

	getUsersList() {
		this.notificationsService.getUserList().subscribe(
			(result: any) => {
				// this.userList =   result.users;
				this.userList = result.users;
				this.getAssignedUserList();
				// console.log(this.userList);
			},
			(err) => {
				console.error("get users list server error");
			}
		);
	}

	// get list of already assigned users of segment
	getAssignedUserList() {
		this.notificationsService
			.getSegmentAssignedUserList(this.data.id)
			.subscribe(
				(result: any) => {
					this.assignedUsers = result.assignedUsers;
					console.log(this.assignedUsers, "user");
					this.removeAssignedUsersFromUserList();
					console.log(this.userList);
				},
				(err) => {
					console.error("get assigned users list server error");
				}
			);
	}

	removeAssignedUsersFromUserList() {
		this.userList = this.userList.filter((user) => {
			return (
				this.assignedUsers.findIndex(
					(assignedUser) => assignedUser.userId === user.userId
				) === -1
			);
		});
	}

	cancel() {
		this.dialogRef.close();
	}

	// for serch functionality
	applyFilter() {
		console.log(this.searchTxt);
		this.notificationsService
			.getFilteredUsersForSegments(this.searchTxt)
			.subscribe((response: any) => {
				this.userList = response.users;
				this.removeAssignedUsersFromUserList();
			});
	}

	selectionChangesUpdate(event) {
		this.userList = event.availableList;
		this.assignedUsers = event.assignedList;
		this.listChanges = event.listChanges;
	}

	saveUsersToSegment() {
		let selectedUsersList = [];

		this.assignedUsers.forEach((userObj) => {
			selectedUsersList.push(userObj.userId);
		});

		const data = {
			id: this.data.id,
			userList: selectedUsersList,
		};

		this.notificationsService.postUserlistDetails(data).subscribe(
			(response: any) => {
				this.dialogRef.close("updated");
				this.msgService.showSuccess(this.msgService.segmentUserlistUpdate);
			},
			(err) => {
				console.error(" server error");
			}
		);
	}
	clear() {
		this.searchTxt = "";
		this.applyFilter();
	}
}
